<template>
    <footer>
        <div class="container">
            <div class="row justify-content-around">
                <div class="col-12 col-lg-5">
                    <a href="https://straalstudio.be">Straalstudio Atelier</a>
                    <a href="https://www.google.com/maps/place/Straalstudio/@51.1269957,4.4182995,17z/data=!4m8!1m2!2m1!1sstraaltsudio!3m4!1s0x47c3fa796ab9873d:0xfeacd496118df9cf!8m2!3d51.1268654!4d4.4206207" target="_blank">Satenrozen 6A, unit 24 - 2550 Kontich<br>(nadien&nbsp;pijlen&nbsp;Straalstudio)</a>
                </div>
                <div class="col-12 col-lg-4">
                    <a href="tel:033037900">03 303 79 00</a>
                    <a href="mailto:info@straalstudio.be">info@straalstudio.be</a>
                    <a href="https://straalstudio.be/algemene-voorwaarden">Algemene voorwaarden</a>
                </div>
                <div class="col-12 col-lg-3">
                    <a class="cta-standard-outline cta-footer" href="https://straalstudio.be/contact">
                        <span class="cta-anim">
                            Contact
                        </span>
                        <span>
                            Contact
                        </span>
                    </a>

                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped lang="scss">
    @import '../../../node_modules/bootstrap/scss/bootstrap';

    // Body
    $body-bg: #f5f8fa;

    // Borders
    $laravel-border-color: darken($body-bg, 10%);
    $list-group-border: $laravel-border-color;
    $navbar-default-border: $laravel-border-color;
    $panel-default-border: $laravel-border-color;
    $panel-inner-border: $laravel-border-color;

    // Brands
    $brand-primary: #D1AD5A;
    $brand-info:    #8eb4cb;
    $brand-success: #2ab27b;
    $brand-warning: #cbb956;
    $brand-danger:  #bf5329;

    // Typography
    $icon-font-path: "~bootstrap-sass/assets/fonts/bootstrap/";
    $font-family-sans-serif: "Montserrat-light", sans-serif;
    $font-size-base: 14px;
    $line-height-base: 1.6;
    $text-color: #636b6f;

    $font-light:    300;
    $font-medium:   500;
    $font-semibold: 600;

    // Navbar
    $navbar-default-bg: #fff;

    // Buttons
    $btn-default-color: $text-color;

    // Inputs
    $input-border: lighten($text-color, 40%);
    $input-border-focus: lighten($brand-primary, 25%);
    $input-color-placeholder: lighten($text-color, 30%);

    // Panels
    $panel-default-heading-bg: #fff;

    // Standard Colors
    $black:     #000;
    $white:     #fff;
    $gray:      #707070;
    $lightgray: #F8F7F7;

    // Straalstudio Colors

    footer {
        background: $lightgray;
        padding: 45px 0;
        text-align: center;
        @include media-breakpoint-up(md){
            text-align: left;
        }
        h3 {
            font-size: .95rem;
            text-transform: uppercase;
        }
        p {
            font-size: .95rem;
        }
        a {
            color: $gray;
            font-size: .95rem;
            display: block;
            transition: all .3s ease;
            line-height: 32px;
            &:hover {
                text-decoration: none;
                color: $black;
            }
        }
        .cta-footer {
            border: 1px solid $brand-primary;
            width: 130px;
            margin: auto;
            @include media-breakpoint-up(md){
                margin-left: 0;
            }
            @include media-breakpoint-up(lg){
                width: 160px;
                margin-left: auto;
                margin-right: 0;
            }
            span {
                color: $brand-primary;
            }

        }
        .col-12 {
            margin-bottom: 30px;
            &:last-child {
                margin-bottom: 0;
            }
            @include media-breakpoint-up(lg){
                margin-bottom: 0;
                &:last-child {
                    text-align: right;
                }
            }
        }
        .cta-standard span, .cta-standard-outline span {
          color: $brand-primary;
          text-decoration: none;
          text-transform: uppercase;
          text-align: center;
          display: block;
          cursor: pointer;
          text-decoration: none;
        }

        .cta-standard, .cta-standard-outline,  .cta-anim {
          transition: all .5s ease;     
          text-decoration: none;
          cursor: pointer;
        }
        .cta-standard-outline {
            height: 64px;
            font: normal normal 700 1em/4em 'Montserrat-semibold',sans-serif;
            font-weight: $font-semibold;
            overflow: hidden;
            display: block;
            width: 220px;
            color: $white;
            text-decoration: none !important;
            background-color: none;
            border: 1px solid $brand-primary;
        }

        .cta-anim {
          margin-top: 0em;   
          cursor: pointer;
          text-decoration: none;
        }

        .cta-standard:hover .cta-anim, .cta-standard-outline:hover .cta-anim {
          margin-top: -4em;
          cursor: pointer;
          text-decoration: none;
        }
    }

</style>